const BRAND_TERMS = ['COONALTRAGAS', 'Coonaltragas'];

const SPLIT_REGEX = /(COONALTRAGAS|Coonaltragas)/g;

export default function BrandTextHighlight({ text, className = 'font-semibold text-[#00A63E]' }) {
  if (!BRAND_TERMS.some((term) => text.includes(term))) {
    return text;
  }

  return text.split(SPLIT_REGEX).map((part, i) =>
    BRAND_TERMS.includes(part) ? (
      <span key={`${part}-${i}`} className={className}>
        {part}
      </span>
    ) : (
      part
    )
  );
}
